
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import JQuery from 'jquery';
    import { Wait } from '@/__env/ext';
    import { Articulo } from '@/__env/lib/Articulos';
    import mini from './articulos-lista-mini.vue';
    import { timingSafeEqual } from 'crypto';
    import { Utiles } from '@/__env/pluggins/event-bus';




    @Component( {
        name: "Componente",
        props: {},
        components: {
            mini,

        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        public get Iniciado() { return this.Controlador.EdicionPedido.Iniciado; }
        public get Modo() { return this.Controlador.Vista.BarraIzquierda.Modo; }
        public Estado: 'cargando' | 'ok' | 'vacio' = 'ok';
        public Focused: boolean = false;
        @Watch( 'Focused' ) onFocused()
        {
            if ( this.Focused )
                Utiles.ElementScrollBottom( document.getElementById( 'form-nuevo-pedido' ) );
        }
        public InputError: boolean = false;
        public InputErrorTimer: boolean = false;
        async onInputError()
        {
            this.InputError = true;
            this.Busqueda = '';
            this.InputErrorTimer = true;
            await Wait( 200 );
            this.InputErrorTimer = false;
            await Wait( 200 );
            this.InputErrorTimer = true;
            await Wait( 200 );
            this.InputErrorTimer = false;
            await Wait( 200 );
            this.InputErrorTimer = true;
            await Wait( 200 );
            this.InputErrorTimer = false;
            this.InputError = false;

        }

        public Items: Articulo[] = [];
        public get Articulo()
        {
            if ( this.Items[this.Seleccionado] )
            {
                return this.Items[this.Seleccionado];
            }
        }
        public Seleccionado: number = -1;
        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        async onBusqueda()
        {
            let bb = this.Busqueda;

            this.Items.clear();
            await Wait( 800 );

            if ( bb == this.Busqueda )
            {
                await this.Buscar();
                this.Seleccionado = -1;

            }
        }

        public async Buscar( forzar?: boolean )
        {
            if ( !this.Busqueda )
            {
                this.Items.clear();
                return;
            } else
            {

                let ff: any = {};

                if ( this.Controlador.Configuracion.Opciones.BuscadorArticulos.OcultarFueraDeLista )
                {
                    ff.fuera_de_lista = 'N';
                }

                if ( this.Controlador.Configuracion.Opciones.BuscadorArticulos.OcultarDesactivados )
                {
                    ff.desactivado = 'N';
                }

                ff.limit = 5;
                ff.q = this.Busqueda;
                ff.details = 'precio';
                ff.opciones_precio = {
                    tipo: this.Controlador.EdicionPedido.Tipo.Lista,
                    cliente: this.Controlador.EdicionPedido.Cliente.Id
                };

                this.Estado = 'cargando';
                let e = await Articulo.find( ff );
                if ( !e.Error )
                {
                    this.Items = e.Items;
                } else
                {
                    this.Items.clear();
                }

                if ( this.Items.hasRows() )
                    this.Estado = 'ok';
                else
                    this.Estado = 'vacio';
            }
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {
            this.Controlador.Vista.BarraIzquierda.Anchura.Espacio = '400px';
        }

        KeyDown( e: KeyboardEvent )
        {
            if ( ['Escape', 'Enter', 'F3', 'PageUp', 'PageDown', 'ArrowDown', 'ArrowUp'].includes( e.key ) )
            {
                e.preventDefault();
            }
        }
        async KeyUp( e: KeyboardEvent )
        {

            if ( e.key == 'Escape' )
            {
                if ( this.Items.hasRows() )
                {
                    this.Items.clear();
                } else
                {
                    this.Busqueda = '';
                }
            }
            else if ( e.key == 'PageUp' )
            {
                this.SeleccionarLista( 0 );
            }
            else if ( e.key == 'PageDown' )
            {
                this.SeleccionarLista( this.Items.length - 1 );
            }
            else if ( e.key == 'ArrowUp' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Seleccionado - 1 );
            }
            else if ( e.key == 'ArrowDown' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Seleccionado + 1 );
            }
            else if ( e.key == 'Enter' )
            {
                if ( this.Items.hasRows() )
                {
                    if ( this.Articulo )
                    {
                        this.Seleccionar( this.Articulo );
                    } else if ( this.Busqueda && this.Busqueda.borraLetras().length > 1 )
                    {

                        if ( ! await this.Seleccionar( this.Busqueda ) )
                        {
                            this.onInputError();
                        }
                    }
                } else if ( this.Busqueda && this.Busqueda.borraLetras().length > 1 )
                {
                    if ( !await this.Seleccionar( this.Busqueda ) )
                    {
                        this.onInputError();
                    }
                }


            }


        }

        public SeleccionarLista( x: number )
        {
            if ( this.Items[x] )
            {
                this.Seleccionado = x;

                if ( !this.isVisibleListaMini( this.Seleccionado ) )
                    this.ScrollToItemListaMini();
            }
        }



        protected ScrollToItemListaMini()
        {
            let element = document.getElementById( 'barra-izquierda-lista-mini' );
            let element2 = document.getElementById( 'barra-izquierda-lista-mini-item-' + this.Seleccionado );
            this.$vuetify.goTo( element2, {

                container: element,
                offset: 20,
                duration: 0,
            } );
        }

        protected isVisibleListaMini( item: number )
        {
            let el = JQuery( '#barra-izquierda-lista-mini-item-' + item );
            let lista = JQuery( '#barra-izquierda-lista-mini' );
            let winTop = lista.scrollTop();
            let winBottom = winTop + lista.height();
            let elTop = el.offset().top;
            let elBottom = elTop + el.height();
            return ( ( elBottom <= winBottom ) && ( elTop >= winTop ) );
        }

        async Seleccionar( x: string | Articulo )
        {
            let e = await this.Controlador.EdicionPedido.NuevoItem.AgregarArticulo( x );
            if ( e.Resultado )
            {
                await Wait( 10 );
                this.Controlador.Vista.BarraIzquierda.Modo = 'cantidad';
                return true;
            } else
            {
                if ( e.Mensaje )
                    Utiles.Notificaciones.Error( e.Mensaje );
            }
            return false;

        }
        AbrirMenu()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'menu';
        }
    }
